module.exports = __webpack_public_path__ + "img/polymer.f0624356.svg";